import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
    const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((it, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: it.label,
            item: `https://thepuropack.com${it.to}`,
        })),
    };
    return (
        <nav aria-label="Breadcrumb" className="pt-6" data-testid="breadcrumbs">
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
            <ol className="flex flex-wrap items-center gap-2 text-xs font-mono uppercase tracking-widest text-stone">
                {items.map((it, i) => (
                    <li key={it.to} className="flex items-center gap-2">
                        {i < items.length - 1 ? (
                            <Link to={it.to} className="hover:text-forest">{it.label}</Link>
                        ) : (
                            <span className="text-forest" aria-current="page">{it.label}</span>
                        )}
                        {i < items.length - 1 && <ChevronRight className="w-3 h-3 opacity-60" />}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
